import type { DocumentViewerCard, TabGroupKind } from '@onefootprint/request-types/dashboard';

const groupCardsByTab = (cards: DocumentViewerCard[]): Record<TabGroupKind, DocumentViewerCard[]> => {
  const grouped: Record<TabGroupKind, DocumentViewerCard[]> = {
    validation: [],
    extraction: [],
    tamper_detection: [],
    classification: [],
    vault_data: [],
  };

  for (const card of cards) {
    const sortedCards = grouped[card.kind];
    sortedCards.push(card);
  }

  // Sort each group by orderingIndex
  for (const kind of Object.keys(grouped) as TabGroupKind[]) {
    grouped[kind].sort((a, b) => (a.orderingIndex ?? 0) - (b.orderingIndex ?? 0));
  }

  return grouped;
};

export default groupCardsByTab;
